import { useContext, createContext } from "react";

export const HistoryContext = createContext();

export const useHistory = () => {
  return useContext(HistoryContext);
};

export default useHistory;
